import { render, staticRenderFns } from "./portal-header.vue?vue&type=template&id=a4de5758&"
import script from "./portal-header.vue?vue&type=script&lang=ts&"
export * from "./portal-header.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports